/**
 * Resuelve los criterios de traspaso a A3 (SUENLACE) aplicables a la empresa
 * con la que se está trabajando.
 *
 * Los criterios están definidos por asesoría (organizations). Si la empresa
 * pertenece a una asesoría concreta, mandan los ajustes de ESA asesoría
 * (importante para administradores que trabajan con empresas de varias
 * asesorías). Si no se conoce la asesoría de la empresa, se usan los ajustes
 * de la asesoría del propio usuario.
 */
import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import {
  DEFAULT_ORG_EXPORT_SETTINGS,
  loadOrganizationExportSettings,
  type OrgExportSettings,
} from "@/lib/organizations";

export const useCompanyExportSettings = (
  companyOrganizationId?: string | null,
): OrgExportSettings => {
  const { orgExportSettings, organizationId } = useAuth();
  const [settings, setSettings] = useState<OrgExportSettings>(orgExportSettings);

  useEffect(() => {
    let cancelled = false;
    const orgId = companyOrganizationId || organizationId || null;
    if (!orgId) {
      setSettings({ ...DEFAULT_ORG_EXPORT_SETTINGS });
      return;
    }
    if (orgId === organizationId) {
      setSettings(orgExportSettings);
      return;
    }
    void loadOrganizationExportSettings(orgId).then((s) => {
      if (!cancelled) setSettings(s);
    });
    return () => {
      cancelled = true;
    };
  }, [companyOrganizationId, organizationId, orgExportSettings]);

  return settings;
};
